<template>
  <Teleport to="body">
    <!-- Modal -->
    <Transition name="modal">
      <div v-if="showSlide" class="modal-mask">
        <div class="modal-container row">
          <div class="col modal-header order-md-1 order-2 row-title">
            <div class="row d-flex justify-content-center align-items-center w-100">
              <div class="col-md-6 d-flex justify-content-center align-items-center">
                <div class="col-3">
                  <div v-if="!loading" class="text-center title left-part">
                    {{ locale == 'pt-br' ? 'Parte' : 'Part' }} {{ partLabel + 1 }}
                  </div>
                </div>
                <div class="col-6">
                  <div v-if="!loading" class="d-flex justify-content-center">
                    <div class="col-7 text-center title">{{ sessionLabel }}</div>
                    <div class="col-5 text-center title">
                      {{ idxCurrent + 1 }} / {{ total + 1 }}
                    </div>
                  </div>
                </div>
                <div class="col-1 d-flex justify-content-end">
                  <div class="div-prev m-top" @click="change" v-if="!loading">
                    <div class="font-prev">
                      <font-awesome-icon
                        :icon="['fas', 'fa-angle-left']"
                        size="md"
                        class="cursor-pointer color-icon"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-2 d-flex justify-content-end">
                  <div class="div-next m-top" @click="change" v-if="!loading">
                    <div class="font-next">
                      <font-awesome-icon
                        :icon="['fas', 'fa-angle-right']"
                        size="md"
                        class="cursor-pointer color-icon"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 d-flex justify-content-center align-items-center">
                <div class="col-lg-10 col-12 slide-controls m-top">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="col-4 text-center">
                      <font-awesome-icon
                        :icon="['fas', 'fa-minus']"
                        size="md"
                        class="cursor-pointer color-icon"
                        @click="minusPlay()"
                        @mouseover="hover = true"
                        @mouseleave="hover = false"
                      />
                    </div>
                    <div class="col-4 text-center">
                      <font-awesome-icon
                        v-if="!slidePlayZoom"
                        :icon="['fas', 'fa-play']"
                        size="md"
                        class="cursor-pointer color-icon"
                        @click="startPlay()"
                        @mouseover="hover = true"
                        @mouseleave="hover = false"
                      />
                      <font-awesome-icon
                        v-else
                        :icon="['fas', 'fa-pause']"
                        size="md"
                        class="cursor-pointer color-icon"
                        @click="stopPlay()"
                        @mouseover="hover = true"
                        @mouseleave="hover = false"
                      />
                    </div>
                    <div class="col-4 text-center">
                      <font-awesome-icon
                        :icon="['fas', 'fa-plus']"
                        size="md"
                        class="cursor-pointer color-icon"
                        @click="plusPlay()"
                        @mouseover="hover = true"
                        @mouseleave="hover = false"
                      />
                    </div>
                    <span
                      class="color-icon size-seconds position-absolute"
                      :style="
                        !hover
                          ? { display: 'none' }
                          : { display: 'block', right: '-35px', top: '-2px' }
                      "
                      >{{ seconds }}s</span
                    >
                  </div>
                </div>
                <div class="m-top">
                  <button
                    v-if="!loading"
                    type="button"
                    class="btn-close btn-desktop"
                    @click="sair"
                    aria-label="Close"
                  ></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col modal-body order-md-2 order-1">
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <button
                  type="button"
                  class="btn-close btn-mobile"
                  @click="sair"
                  aria-label="Close"
                ></button>
                <div class="text-center mt-5 p-5 div-loading" v-if="loading">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <img
                  class="cursor-pointer"
                  v-else
                  :src="img"
                  @click="startStopPlay()"
                  width="1280"
                  height="1920"
                  :alt="sessionLabel"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { userStore } from 'stores/user'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import { event } from 'vue-gtag'

  export default defineComponent({
    name: 'ModalModelSlideShow',
    props: [
      'showSlide',
      'imgSlide',
      'translate',
      'total',
      'session',
      'loading',
      'sessionLabel',
      'partLabel',
      'idxCurrent',
      'slidePlayZoom',
      'seconds',
      'keyDownEvents'
    ],
    emits: [
      'showModalModelSlideShow',
      'changePhoto',
      'showModalSubscribePlans',
      'updateSlidePlayZoom',
      'updateSeconds'
    ],
    computed: {
      ...mapState(userStore, ['isActiveUser']),
      ...mapState(localeStore, ['locale'])
    },
    data() {
      return {
        current: 0,
        img: '',
        interval: null,
        hover: false
      }
    },
    watch: {
      imgSlide: function (value) {
        if (value) {
          this.current = this.idxCurrent
          this.img = value
        }
      },
      slidePlayZoom: function (val) {
        if (val == true) {
          this.startPlay()
        } else {
          clearInterval(this.interval)
        }
      },
      keyDownEvents: function (val) {
        if (val) {
          window.addEventListener('keydown', this.handleKeydownZoom, null)
        } else {
          window.removeEventListener('keydown', this.handleKeydownZoom)
        }
      }
    },
    methods: {
      change(eventChange) {
        //Avançar
        if (this.current === this.total && eventChange.target.closest('div.div-next') != null) {
          if (!this.isActiveUser) {
            this.$emit('showModalModelSlideShow', false)
            this.$emit('showModalSubscribePlans', true)
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada - Modo SlideShow'
              }
            })
            event('paywall2', {
              paywall: {
                acionador:
                  'Ao finalizar seção gratis e avançar para uma seção de fotos bloqueada - Modo SlideShow'
              }
            })
          } else {
            this.$emit('changeAutomatic', true)
          }
          return false
        }
        //Voltar
        if (this.current === 0 && eventChange.target.closest('div.div-prev') != null) {
          if (!this.isActiveUser) {
            this.$emit('showModalModelSlideShow', false)
            this.$emit('showModalSubscribePlans', true)
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'paywall',
              paywall: {
                acionador:
                  'Ao retornar de uma seção gratis e retornar para uma seção de fotos bloqueada - Modo SlideShow'
              }
            })
            event('paywall2', {
              paywall: {
                acionador:
                  'Ao retornar de uma seção gratis e retornar para uma seção de fotos bloqueada - Modo SlideShow'
              }
            })
          } else {
            this.$emit('changeAutomatic', false)
          }
          return false
        }

        if (eventChange.target.closest('div.div-next') != null) this.current++
        else this.current--

        this.$emit('changePhoto', this.current)
      },
      async sair() {
        await this.$emit('changeSession', {
          part: this.partLabel,
          session: this.session,
          next: true,
          zoom: this.current
        })
        await this.$emit('showModalModelSlideShow', false)
        this.img = ''
      },
      startPlay() {
        clearInterval(this.interval)
        this.$emit('updateSlidePlayZoom', true)
        var cont = 0
        this.interval = setInterval(function () {
          if (document.getElementsByClassName('font-next').length && cont > 0) {
            cont = 0
            document.getElementsByClassName('font-next')[0].click()
          } else if (document.getElementsByClassName('font-next').length) cont = 1
        }, this.seconds * 1000)
      },
      stopPlay() {
        this.$emit('updateSlidePlayZoom', false)
      },
      async minusPlay() {
        if (this.seconds > 1) {
          await this.$emit('updateSeconds', this.seconds - 1)
          this.startPlay()
        }
      },
      async plusPlay() {
        if (this.seconds < 10) {
          await this.$emit('updateSeconds', this.seconds + 1)
          this.startPlay()
        }
      },
      startStopPlay() {
        if (this.slidePlayZoom) {
          this.stopPlay()
        } else {
          this.startPlay()
        }
      },
      handleKeydownZoom(e) {
        if (e.keyCode == 37) {
          //Arrow Left
          if (document.getElementsByClassName('font-prev').length) {
            document.getElementsByClassName('font-prev')[0].click()
          }
        } else if (e.keyCode == 39) {
          //Arrow Right
          if (document.getElementsByClassName('font-next').length) {
            document.getElementsByClassName('font-next')[0].click()
          }
        } else if (e.keyCode == 38) {
          //Arrow Up
          e.preventDefault()
          this.plusPlay()
          this.hover = true
          setTimeout(() => {
            this.hover = false
          }, 2000)
        } else if (e.keyCode == 40) {
          //Arrow Down
          e.preventDefault()
          this.minusPlay()
          this.hover = true
          setTimeout(() => {
            this.hover = false
          }, 2000)
        } else if (e.keyCode == 13 || e.keyCode == 32) {
          //Enter or Space
          e.preventDefault()
          this.startStopPlay()
          this.hover = true
          setTimeout(() => {
            this.hover = false
          }, 2000)
        }
      }
    }
  })
</script>

<style scoped lang="css">
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    transition: opacity 0.3s ease;
    overflow-y: auto;
  }

  .modal-container {
    max-width: 1460px;
    width: 100%;
    margin: auto;
    padding: 0px;
    background-color: #fff;
    border-radius: 0px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
  }

  .modal-header {
    height: 70px;
  }

  .modal-body {
    margin: 0;
  }

  .modal-body img {
    max-width: 100%;
    object-fit: cover;
    height: auto;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter-from {
    opacity: 0;
  }

  .modal-leave-to {
    opacity: 0;
  }

  .modal-body {
    margin: 10px 0;
  }

  .modal-enter-from .modal-container,
  .modal-leave-to .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .btn-close {
    opacity: 1;
  }

  .btn-mobile {
    top: 30px;
    right: 30px;
    position: absolute;
    display: none;
    z-index: 1;
    color: black;
  }

  .color-icon {
    color: #5b5858;
  }

  .div-loading {
    min-height: 1920px;
  }

  .title {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    top: 5px;
  }

  .slide-controls {
    width: 270px;
    border: 1px solid #000;
    border-radius: 30px;
  }

  .m-top {
    margin-top: 10px;
  }

  .size-seconds {
    font-size: 14px;
    color: white;
    background-color: #5b5858;
    border-radius: 50%;
    width: 27px;
    height: 27px;
    padding: 3px 6px;
  }

  .btn-desktop {
    display: block;
    left: 150px;
  }

  .left-part {
    padding-left: 40px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .btn-mobile {
      display: block;
      font-size: 30px;
    }

    .modal-header {
      height: 60px;
    }
    .title {
      font-size: 16px;
      top: unset;
    }
    .div-loading {
      min-height: 520px;
    }
    .m-top {
      margin-top: 0px;
    }
    .btn-desktop {
      display: none;
    }
    .left-part {
      padding-left: 0px;
    }

    .slide-controls {
      margin: 15px;
    }
    .row-title {
      height: 100px;
    }
  }
</style>
